//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MHeader from '../../Header/Header.vue';
import {
    updatePwd
} from '../../../api';
export default {
    components: {
        MHeader,
    },
    data() {
        return {
            old: "",
            new1: "",
            new2: ""
        }
    },
    methods: {
        sbmt(old, new1, new2) {
            if (!old) {
                this.$store.commit('updateToast', {
                    text: '请输入原密码',
                    show: true
                });
                return;
            };
            if (!new1) {
                this.$store.commit('updateToast', {
                    text: '请输入新密码',
                    show: true
                });
                return;
            };
            if (new1 != new2) {
                this.$store.commit('updateToast', {
                    text: '两次输入密码不一致',
                    show: true
                });
                return;
            };
            updatePwd(`old_pwd=${old}&confirm_pwd=${new1}&new_pwd=${new2}`).then(res => {
                if (res.data.error_code) {
                    this.$store.commit('updateToast', {
                        show: true,
                        text: res.data.msg
                    });
                    console.error(res);
                    return;
                };
                this.$router.go(-1);
                this.$store.commit('updateToast', {
                    show: true,
                    text: '密码修改成功'
                });
            })
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/UserCenter/changPassword/changPassword.vue